import { ICapsuleFolder, IExploringElement } from "../../typings/board/Models";

export class ExploringElement implements IExploringElement {
    constructor(
        public leftPadding : number,
        public folderName: string,
        public isSelected : boolean,
        public parent: ICapsuleFolder,
        public isVisible: boolean,
        public originCapsule: ICapsuleFolder) {
        }
}


// WEBPACK FOOTER //
// ./app/hierarchy-support/exploringElement.ts